import { WithChildren } from '@/_metronic/helpers'
import { BaseRequest } from '@/_metronic/helpers/crud-helper/base-request'
import { createContext, FC, useContext, useState } from 'react'
import { FilterDashboardHR, initialFilter } from './_models'

type ProductQueryRequestContextProps = {
  state: FilterDashboardHR
  updateState: (updates: Partial<FilterDashboardHR>) => void
}

const initialQueryRequest = {
  state: initialFilter,
  updateState: () => {},
}

const QueryRequestContext = createContext<ProductQueryRequestContextProps>(initialQueryRequest)

const QueryRequestProvider: FC<WithChildren> = ({children}) => {
  const [state, setState] = useState<FilterDashboardHR>(initialQueryRequest.state)

  const updateState = (updates: Partial<FilterDashboardHR>) => {
    const updatedState = {...state, ...updates} as FilterDashboardHR
    setState(updatedState)
  }

  return (
    <QueryRequestContext.Provider value={{state, updateState}}>
      {children}
    </QueryRequestContext.Provider>
  )
}

const useQueryRequest = () => useContext(QueryRequestContext)
export { QueryRequestProvider, useQueryRequest }

